import { render, staticRenderFns } from "./advert-banner.vue?vue&type=template&id=38abc9b0"
import script from "./advert-banner.vue?vue&type=script&lang=js"
export * from "./advert-banner.vue?vue&type=script&lang=js"
import style0 from "./advert-banner.vue?vue&type=style&index=0&id=38abc9b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports